import { ISelectOption, LinkButton, Select, type TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

import { PriceCategorySection } from './components/PriceCategorySection';
import { PriceDealTypeTabs } from './components/PriceDealTypeTabs';
import * as styles from './styles.css';

import type { IPriceCategory, PriceDealType } from 'shared/types/pricesTable';
import { DEFAULT_LINK_BUTTON_PROPS } from 'shared/constants/link-button-defaults';
import { PROMO_LINK } from 'shared/constants/links';

export interface IPricesProps {
  polygons: ISelectOption[];
  selectedValue: string | undefined;
  onPolygonChange: (value: string) => void;
  dealType: PriceDealType;
  onDealTypeChange: (value: PriceDealType) => void;
  categories: IPriceCategory[];
  device: TDeviceType;
  dealTypeColumnTitle: string;
}

export const Prices: React.FC<IPricesProps> = ({
  polygons,
  selectedValue,
  onPolygonChange,
  dealType,
  onDealTypeChange,
  categories,
  device,
  dealTypeColumnTitle,
}) => {
  return (
    <div className={clsx(styles['container'], styles[device])} data-testid="Prices">
      <div className={styles['selector']}>
        <Select onChange={onPolygonChange} value={selectedValue} options={polygons} size="M" />
      </div>
      <PriceDealTypeTabs value={dealType} onChange={onDealTypeChange} />
      <div className={styles['prices-table__wrapper']}>
        <table className={styles['prices-table']}>
          <thead className={styles['prices-table__head']}>
            <tr className={styles['prices-table__head-row']}>
              <th className={styles['prices-table__cell']}>{dealTypeColumnTitle}</th>
              <th className={styles['prices-table__cell']}>Ставка за просмотр</th>
              <th className={styles['prices-table__cell']}>Мин. дневной лимит</th>
              <th className={styles['prices-table__cell']}>Шаг ставки</th>
            </tr>
          </thead>
          {categories.length === 0 ? (
            <tbody className={styles['prices-table__body']}>
              <tr className={styles['prices-table__error-row']}>
                <td className={styles['prices-table__error-cell']} colSpan={4}>
                  Что-то пошло не так, попробуйте позже
                </td>
              </tr>
            </tbody>
          ) : (
            categories.map(category => (
              <tbody key={category.categoryName} className={styles['prices-table__body']}>
                <PriceCategorySection categoryName={category.categoryName} rows={category.rows} />
              </tbody>
            ))
          )}
        </table>
      </div>
      <div className={styles['btn-container']}>
        <LinkButton {...DEFAULT_LINK_BUTTON_PROPS} href={PROMO_LINK}>
          Подробнее
        </LinkButton>
      </div>
    </div>
  );
};
